import { useState } from 'react';
import type { Locale } from '../i18n';

export type IsolationSettings = { failureLimit: number; failureWindowSeconds: number };

export function AgentIsolationSettings({ settings, locale, pending, onSave }: {
  settings: IsolationSettings;
  locale: Locale;
  pending: boolean;
  onSave: (settings: IsolationSettings) => void;
}) {
  const [limit, setLimit] = useState(String(settings.failureLimit));
  const [windowSeconds, setWindowSeconds] = useState(String(settings.failureWindowSeconds));
  const en = locale === 'en';
  return <form className="agent-isolation-settings" aria-label={en ? 'Automatic isolation policy' : '自动隔离策略'} onSubmit={event => {
    event.preventDefault();
    onSave({ failureLimit: Number(limit), failureWindowSeconds: Number(windowSeconds) });
  }}>
    <strong>{en ? 'Automatic isolation policy' : '自动隔离策略'}</strong>
    <label>{en ? 'Observation window (seconds)' : '观察时间（秒）'}
      <input type="number" min={10} max={3600} step={1} required value={windowSeconds} disabled={pending} onChange={event => setWindowSeconds(event.target.value)} />
    </label>
    <label>{en ? 'Consecutive failures' : '连续失败次数'}
      <input type="number" min={1} max={1000} step={1} required value={limit} disabled={pending} onChange={event => setLimit(event.target.value)} />
    </label>
    <button className="button button-outline" type="submit" disabled={pending || (Number(limit) === settings.failureLimit && Number(windowSeconds) === settings.failureWindowSeconds)}>{en ? 'Save policy' : '保存策略'}</button>
    <small>{en ? 'Default: 12 failures within 120 seconds. Saved changes apply to subsequent results; isolated nodes still require a recovery test.' : '默认：120 秒内连续失败 12 次。保存后对后续结果即时生效，已隔离节点仍需通过恢复自检。'}</small>
  </form>;
}
